import React, {useState,useCallback} from 'react';
import {RoleRouter} from '@putil-view/auth.role-router';
import NavBar from 'main/NavBar';
import Body from 'main/Body';
import Footer from 'main/Footer';
import {SysPath} from 'SysContext';
import "css/r-board.css";
const Board = () => {

  const [state, setState] = useState({role: null})
	const handleRole = useCallback((role) =>{
    if(role){
      setState({role:role});
    }
	},[setState])
  const config = {
    roleUrl: SysPath.roleUrl  + '?url=' + encodeURIComponent(window.location.href),
    role:{
      admin:{
        name:'elocker_admin',
        success: '/match',
        failed: '/404'
      },
      user: {
        name:'user',
        success: '/match',
        failed: '/404'
      },
      guest:{
        name:'guest',
        success: '/match',
        failed: '/404'
      }
    }
  }
  return(
      <RoleRouter baseName='/elocker' className='r-board' config={config} role={state.role} handleRole={handleRole} >
        <NavBar role={state.role}/>
        <Body role={state.role}/>
        <Footer/>
      </RoleRouter>
  )
}

export default Board;
